
import api from './api';

const endpoint = '/api/horarios';

const HorariosService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getByDiaSemanaAtivo: async () => {
    const response = await api.get(`${endpoint}/dia-semana-ativo`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  },

  getByDiaSemana: async (diaSemana) => {
    const response = await api.get(`${endpoint}/dashboard/${diaSemana}`);
    return response.data;
  },

  getDisponiveis: async (data) => {
    const response = await api.get(`${endpoint}-disponiveis/`, {
      params: { data }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post(endpoint, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${endpoint}/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default HorariosService;